import { TabContext, TabPanel } from "@mui/lab";
import { Box } from "@mui/system";
import * as React from "react";
import useTabParam from '../../hooks/useTabParam';
import PageTitle from "../../components/PageTitle";
import LabelDIY from "./LabelDIY";
import LabelConfig from "./LabelConfig";
import TuneIcon from '@mui/icons-material/Tune';
import UploadIcon from '@mui/icons-material/Upload';

const TABS = [
  { value: "1", label: "Upload & View Labels", icon: <UploadIcon sx={{ fontSize: 18 }} /> },
  { value: "2", label: "Customize Labels", icon: <TuneIcon sx={{ fontSize: 18 }} /> },
];

function LabelTabs() {
  const [value, setValue] = useTabParam("1");

  return (
    <>
      <PageTitle>Label Configuration</PageTitle>
      <TabContext value={value}>
        {/* Modern segmented tabs — bold filled active, outlined inactive, so it clearly reads as tabs */}
        <Box sx={{ display: "inline-flex", gap: 1.25, mb: 2 }}>
          {TABS.map((t) => {
            const active = value === t.value;
            return (
              <Box
                key={t.value}
                onClick={() => setValue(t.value)}
                role="tab"
                aria-selected={active}
                sx={{
                  display: "flex", alignItems: "center", gap: 0.9, cursor: "pointer",
                  px: 2.75, py: 1.15, borderRadius: "10px", fontSize: 13.5, whiteSpace: "nowrap",
                  fontFamily: "Poppins, sans-serif", fontWeight: 700, letterSpacing: "0.2px",
                  transition: "all 0.15s ease", border: "1.5px solid",
                  borderColor: active ? "#1565c0" : "#D5DBE3",
                  color: active ? "#fff" : "#64748b",
                  bgcolor: active ? "#1565c0" : "#fff",
                  boxShadow: active ? "0 4px 12px rgba(21,101,192,0.25)" : "0 1px 2px rgba(15,23,42,0.05)",
                  "&:hover": active ? { filter: "brightness(0.96)" } : { borderColor: "#1565c0", color: "#1565c0", bgcolor: "rgba(21,101,192,0.05)" },
                }}
              >
                {t.icon}
                <Box component="span">{t.label}</Box>
              </Box>
            );
          })}
        </Box>
        <TabPanel value="1" sx={{ px: 0 }}>
          <LabelConfig />
        </TabPanel>
        <TabPanel value="2" sx={{ px: 0 }}>
          <LabelDIY />
        </TabPanel>
      </TabContext>
    </>
  );
}

export default LabelTabs;
